/**
 * Small reusable social button — rendered in the landing footer and the
 * dashboard sidebar so signed-in users can also discover the LinkedIn page
 * without hunting for it on the homepage.
 *
 * `data-testid="social-linkedin"` on the anchor so we can assert visibility
 * in end-to-end tests. `noopener noreferrer` for security; `rel="me"` so
 * search engines can associate our LinkedIn identity with the domain
 * (helps E-E-A-T signals and knowledge panels).
 */
import { Linkedin } from 'lucide-react';
import { trackEvent } from '../lib/analytics';

export const LINKEDIN_URL = 'https://www.linkedin.com/company/drone-maps-europe';

export function LinkedInLink({
  className = 'inline-flex items-center gap-1.5 text-slate-400 hover:text-white text-sm transition-colors',
  label = 'LinkedIn',
  showLabel = true,
}) {
  return (
    <a
      href={LINKEDIN_URL}
      target="_blank"
      rel="noopener noreferrer me"
      aria-label="Suivre Drone Maps sur LinkedIn"
      className={className}
      data-testid="social-linkedin"
      onClick={() => trackEvent('cta_clicked', { name: 'linkedin_follow' })}
    >
      <Linkedin className="w-4 h-4" />
      {showLabel && <span>{label}</span>}
    </a>
  );
}

export default LinkedInLink;
